import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../../services/AxiosInstance";
import MultiSelect from "../../../Forms/Element/MultiSelect";

/**
 * Exibe as categorias do produto.
 */
const CategoryMultiSelect = (props) => {
   
    const { t } = useTranslation();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        axiosInstance.get("/main/categories", null).then((response) => {
            let options = [];

            for (var i = 0; i < response.data.length; i++) {
                options.push(
                    {
                        value: response.data[i].id,
                        label: response.data[i].name
                    }
                );

                setOptions(options);
            }
        });
    }, []);

    return (
        <MultiSelect
            options={options}
            placeholder={t("select")}
            {...props} />
    )
}

export default CategoryMultiSelect;